import { Text, Anchor, Image } from "@mantine/core";

const SidedBottomBar = () => (
    <div
        style={{
            display: "flex",
            justifyContent: "center",
            padding: "9px 0px",
            gap: "5px",
            alignItems: "center",
            borderTop: "1px solid #E9ECEF",
        }}
    >
        <Text size="xs">Powered by{"  "}</Text>
        <Anchor href="https://business.sided.co" target="_blank" rel="noopener noreferrer">
            <Image
                src="https://sided-stage-embed-v2.s3.us-east-2.amazonaws.com/logo.svg"
                alt="sided logo"
                w={32}
                h={10}
            />
        </Anchor>
    </div>
);

export default SidedBottomBar;